<template lang="pug">
  .div
    .columns
      h1.is-size-4
          strong Formulario Vehículo
    .columns.is-vcentered
      .column.is-4
        .field
          label.label Marca
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Marca..',
                v-model="marca",
                :disabled="isDisabled"
              )
      .column.is-4
        .field
          label.label Modelo
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Modelo',
                v-model="modelo",
                :disabled="isDisabled"
              
              )
      .column.is-4
        .field
          label.label Año
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Año..',
                v-model="year",
                :disabled="isDisabled"
              )
    .columns.is-vcentered
      .column.is-4
        .field
          label.label Categoría:
          .control
            .select.is-primary
              select(v-model="categoriaSel" :disabled="isDisabled")
                option Categoría
                option(v-for="cat in categorias" :key="cat.id" :value="cat") {{cat.nombre}}
      .column.is-4
        .field
          label.label Color
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Color..',
                v-model="color",
                :disabled="isDisabled"
              )
      .column.is-4
        .field
          label.label Placas
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Placas..',
                v-model="placas",
                :disabled="isDisabled"
              )
    .columns.is-vcentered
      .column.is-4
        .field
          label.label # Motor
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='# Motor..',
                v-model="motor",
                :disabled="isDisabled"
              )
      .column.is-4
        .field
          label.label Serie
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Serie..',
                v-model="serie",
                :disabled="isDisabled"
              )
      .column.is-4
        .fiel
          label.label Combustible
          .control
            .select.is-primary
              select(v-model="combustibleSel" :disabled="isDisabled")
                option Tipo Combustible
                option(v-for="gas in combustibles" :key="gas.id" :value="gas") {{gas.nombre}}
    .columns(v-show="!isEditing")
      .column.is-3
        a.button.is-primary.is-block(@click="editar")
          | Editar 
    .columns(v-show="isEditing")
      .column.is-3
        a.button.is-block(@click="cancelEdit")
          | Cancelar 
      .column.is-3
        a.button.is-black.is-block(@click="checkForm")
          | Actualizar 
    .columns(v-show="datosFaltantes.length > 0")
      .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  import ResponsivasService from '@/services/inventario/responsivas'

  export default {
    name: 'FormEditVehiculo',
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      dataBD: {
        type: Object,
        default: () => {}
      },
      desHabilitar: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        marca: null,
        modelo: null,
        categoriaSel: {},
        year: null,
        motor: null,
        color: null,
        placas: null,
        serie: null,
        combustibleSel: {},
        datosFaltantes: [],
        isDisabled: false,
        datosForm: {},
        categorias: [
          { id: 1, nombre: 'AUTOMOVIL'},
          { id: 2, nombre: 'CAMIONETA'},
          { id: 3, nombre: 'VAN'},
          { id: 4, nombre: 'TRACTOR'}
        ],
        combustibles: [
          { id: 1, nombre: 'GASOLINA STD.'},
          { id: 2, nombre: 'GASOLINA PREMIUM'},
          { id: 3, nombre: 'DIESEL'}
        ],
        isEditing: false
      }
    },
    watch: {
      item() {
        if (Object.keys(this.item).length > 0) {
          this.marca = this.item.marca
          this.modelo = this.item.modelo
          this.serie = this.item.serie
        }
      },
      desHabilitar() {
        //console.log(`Deshabilitar Form_Vehiculo: ${this.desHabilitar}`)
        if (this.desHabilitar) {
          //console.log('deshabiliatr true')
          this.isDisabled = true
        } else {
          //console.log('deshabiliatr false')
          this.isDisabled = false
        }
        this.isEditing = false
      }, 
      dataBD() {
        console.log('Se actualizó la dataBD del form Vehiculo')
        this.marca = this.dataBD.marca
        this.modelo = this.dataBD.modelo
        this.year = this.dataBD.anio_modelo
        this.motor = this.dataBD.motorStr
        this.color = this.dataBD.color
        this.placas = this.dataBD.placas
        this.serie = this.dataBD.serie
        this.categoriaSel = this.categorias.find(cat => cat.nombre === this.dataBD.categoria)
        this.combustibleSel = this.combustibles.find(comb => comb.id === this.dataBD.gasolina)
      }
    },
    methods: {
      checkForm() {
        this.datosFaltantes = []
        if (this.marca && this.modelo && Object.keys(this.categoriaSel).length > 0 && this.year && this.motor && this.color && this.placas && this.serie && Object.keys(this.combustibleSel).length > 0) {
          let myObject = {
            marca: this.marca,
            modelo: this.modelo,
            idCategoria: this.categoriaSel.id,
            categoria: this.categoriaSel.nombre,
            year: this.year,
            motor: this.motor,
            color: this.color,
            placas: this.placas,
            serie: this.serie,
            gasolina: this.combustibleSel.id,
            combustible: this.combustibleSel.nombre
          }
          this.isDisabled = true
          this.isEditing = false
          this.datosForm = Object.assign({}, this.datosForm, myObject)
          this.guardar()
        } else {
          if (!this.marca) {
            this.datosFaltantes.push('La Marca es requerida.')
          }
          if (!this.modelo) {
            this.datosFaltantes.push('El Modelo es requerido.')
          }
          if (!this.year) {
            this.datosFaltantes.push('El Año es requerido.')
          }
          if (!this.motor) {
            this.datosFaltantes.push('El # de Motor es requerido.')
          }
          if (!this.color) {
            this.datosFaltantes.push('El Color es requerido.')
          }
          if (!this.placas) {
            this.datosFaltantes.push('Las Placas son requeridas.')
          }
          if (!this.serie) {
            this.datosFaltantes.push('La Serie es requerida.')
          }

          if (Object.keys(this.categoriaSel).length == 0) {
            this.datosFaltantes.push('La Categoría es requerida.')
          }

          if (Object.keys(this.combustibleSel).length == 0) {
            this.datosFaltantes.push('El tipo de Combustible es requerido.')
          }
        }
      },
      guardar() {
        this.isEditing = false
        this.$emit('updateFormVehiculo', true)
        this.$emit('closeForm', this.datosForm)
      },
      cancelEdit() {
        console.log('Cancel Edit')
        this.datosFaltantes = []
        this.isDisabled = true
        this.isEditing = false
        console.log('Cancelar')
        this.$emit('closeForm','close')
      },
      editar () {
        this.isEditing = true
        this.isDisabled = false
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/FormVehiculo_Edit.vue